var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-1535 1274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(1535 -1274)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-bell",
    "data-name": "Icon feather-bell",
    transform: "translate(1548.592 -1267.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M169.064,147.823H3.8A7.8,7.8,0,0,1-.526,133.528c.156-.112,24.069-17.689,24.069-76.139a62.89,62.89,0,1,1,125.78,0c0,58.45,23.914,76.026,24.155,76.2a7.869,7.869,0,0,1,2.978,8.765A7.776,7.776,0,0,1,169.064,147.823ZM20.981,132.218h130.9c-8.536-13.061-18.167-36.328-18.167-74.828a47.285,47.285,0,0,0-94.569,0C39.149,95.89,29.517,119.157,20.981,132.218Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-2",
    d: "M30.591,47.754A26.245,26.245,0,0,1,7.958,34.718a7.8,7.8,0,0,1,13.5-7.83,10.56,10.56,0,0,0,18.268,0,7.8,7.8,0,1,1,13.5,7.83A26.245,26.245,0,0,1,30.591,47.754Z",
    transform: "translate(55.842 145.943)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2e816833de686625e652ce904fb8f375.svg";
export { ForwardRef as ReactComponent };